import Autocomplete from 'common/components/autocomplete'

type Option = {
  value: string
  label: string
}

type Props = {
  onSearch: (value: string) => void
  options: Option[] | undefined
  placeholder?: string
  'aria-label'?: string
}

const PersonalizationAutocomplete = ({
  onSearch,
  options,
  placeholder = 'Find',
  'aria-label': ariaLabel,
}: Props) => {
  return (
    <Autocomplete
      className="w-60 ml-4"
      aria-label={ariaLabel}
      placeholder={placeholder}
      options={options}
      onSearch={onSearch}
      backspaceRemovesValue={true}
    />
  )
}

export default PersonalizationAutocomplete
